module.exports = __webpack_public_path__ + "img/specialeffects-1_cn.cf9cbf2.jpg";